import { render, staticRenderFns } from "./CapacityModal.vue?vue&type=template&id=37b0e9c2&scoped=true&"
import script from "./CapacityModal.vue?vue&type=script&lang=js&"
export * from "./CapacityModal.vue?vue&type=script&lang=js&"
import style0 from "./CapacityModal.vue?vue&type=style&index=0&id=37b0e9c2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37b0e9c2",
  null
  
)

export default component.exports